export default __webpack_public_path__ + "static/media/BAIDU.486dbe6f.png";